module.exports = __webpack_public_path__ + "static/media/wix.0b7ecb20.svg";